export const DEFAULT_WEBSITE_HINT = 'mydomain.com';
export const G2_REVIEWS_URL = 'https://www.g2.com/products/newo-ai/reviews';
export const G2_REVIEWS_IMAGE_URL =
	'https://storage.cloud.google.com/newo-static-files/vibe-crator/image%2030.svg?authuser=0';
